export default __webpack_public_path__ + "static/media/PatriotAct.7a408aec.jpeg";